var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCards = function SvgCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.141 3.95306L17.416 5.53657C18.4579 5.81574 19.0762 6.88667 18.797 7.92855L16.2696 17.361C15.9905 18.4029 14.9195 19.0212 13.8776 18.742L8.21817 17.2256C7.52038 17.0386 7.01259 16.4965 6.83716 15.8458",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.86401,
    y: 2,
    width: 9.76521,
    height: 13.7436,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgCards;